import axios from 'axios';
import authService from './authService';
import historyService from './historyLocalStorageService';
import { getAuthHeader } from './utils/authHelper';
import noFalseParams from './utils/noFalsyParams';
import { getEnv } from '../utils/envUtils';

const STATISTICS_API_URL = getEnv('REACT_APP_STATISTICS_API');

const postToGetStats = (params) => {
    const noFalsy = noFalseParams(params);

    const buildRequest = () => ({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: getAuthHeader(),
        },
        data: noFalsy,
        url: `${STATISTICS_API_URL}/statistics/companies/summaries`,
    });

    return axios(buildRequest())
        .then(response => response.data)
        .catch(err => authService.refreshAndRetry(err, buildRequest)
            .then(response => response.data));
};

const getCompanyStats = (formData) => {
    const hids = formData.hid.split(',').map(word => word.trim()).filter( w => w);

    const params = {
        from: formData.from,
        to: formData.to,
        hid: hids,
        orgNo: hids.length === 0 ? formData.orgNo.split(',').map(word => word.trim()).filter(w => w) : '',
        perDay: true,
    };

    return postToGetStats(params);
};

const extractHIDFromEventualUrl = (string) => {
    const parts = string.split('-');
    const lastPart = parts[parts.length - 1];
    return lastPart.split('?')[0];
};

const getCompanyReportStats = (formData, useOrderPeriod) => {
    const params = {
        from: useOrderPeriod ? formData.orderFrom : formData.from,
        to: useOrderPeriod ? formData.orderTo : formData.to,
        hid: formData.searchType === 'HID' || formData.searchType === 'ORDER_NUMBER' ? formData.HID.split(',').map(string => extractHIDFromEventualUrl(string)) : [],
        orgNo: formData.searchType === 'ORG_NUMBER' ? formData.ORG_NUMBER.split(',').map(word => word.trim()) : [],
        companyName: formData.searchType === 'COMPANY_NAME' ? formData.COMPANY_NAME : '',
        perDay: false,
    };

    switch (formData.searchType) {
    case 'COMPANY_NAME':
        historyService.addCompanyNameHistory(formData.COMPANY_NAME);
        break;
    case 'ORG_NUMBER':
        historyService.addOrgNoHistory(formData.ORG_NUMBER);
        break;
    case 'HID':
        historyService.addHidHistory(formData.HID);
        break;
    case 'ORDER_NUMBER':
        historyService.addOrderHistory(formData.ORDER_NUMBER);
        break;
    default:
        break;
    }
    return postToGetStats(params);
};

const api = {
    getCompanyStats,
    getCompanyReportStats,
};

export default api;
